import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { RankingDetailPage } from '~/features/rankings/components/RankingDetailPage'

const rankingDetailSearchSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  region: z.string().optional(),
})

export const Route = createFileRoute('/{-$locale}/_public/rankings/$snapshotId')({
  validateSearch: rankingDetailSearchSchema,
  component: RankingDetailPage,
})
